// extracted by mini-css-extract-plugin
export default {"page":"app_page__7iei5","content":"app_content__T+cwl","shell":"app_shell__dX-jk"};